import { ListColumn, ListDataColumn } from './Data/ListColumn';

export const CODE: string = 'code';
export const NAME: string = 'name';
export const SOC_CODE: string = 'soc_code';
export const SOC_NAME: string = 'soc_name';
export const HLGT_CODE: string = 'hlgt_code';
export const HLGT_NAME: string = 'hlgt_name';
export const HLT_CODE: string = 'hlt_code';
export const HLT_NAME: string = 'hlt_name';
export const PT_CODE: string = 'pt_code';
export const PT_NAME: string = 'pt_name';
export const LLT_CODE: string = 'llt_code';
export const LLT_NAME: string = 'llt_name';

export const RECEIVER: string = 'receiver';
export const SENDER: string = 'sender';
export const RECEIVE_DATE: string = 'receiveDate';
export const RECEIVE_DATE_FROM: string = 'receiveDateFrom';
export const RECEIVE_DATE_UP_TO: string = 'receiveDateUpTo';
export const SEND_DATE: string = 'sendDate';
export const SEND_DATE_FROM: string = 'sendDateFrom';
export const SEND_DATE_UP_TO: string = 'sendDateUpTo';


export const EQUALOPERATOR: string = 'eq';
export const INOPERATOR: string = 'in';
export const CONTAINSOPERATOR: string = 'cn';
export const GREATERTHANOPERATOR: string = 'gt';
export const LOWERTHANOPERATOR: string = 'lt';
export const LIMIT_FOR_HISTORIES: number = 50;

export const NUMBER_OF_ITEM_DISPLAYED: string =  "Number of items displayed:";
export const MAXIMUN_NUMBER_OF_ITEMS_RETURNED: string = "Maximum number of items returned";
export const PLEASE_USE_PAGINATION_BUTTON = "Use pagination buttons to go to the previous/next page(s).";

export const OPERATOR_LABEL_DICCIONARY: { [key in string]: string } = {
    'eq': 'Match',
    'sw': 'Starts with',
    'cn': 'Contains',
    'ew': 'Ends with',
    'in': 'With'
}  
  
  export const MeddraQueryField: { [key in string]: ListColumn } = {
    "socCode": new ListColumn("SOC Code", ListDataColumn.TEXT, "code"),
    "socName": new ListColumn("SOC Name", ListDataColumn.TEXT, "name"),
    "socAbbreviation": new ListColumn("Abbreviation", ListDataColumn.TEXT, "abbreviation"),
    "hlgtCode": new ListColumn("HLGT Code", ListDataColumn.TEXT, "code"),
    "hlgtName": new ListColumn("HLGT Name", ListDataColumn.TEXT, "name"),
    "hltCode": new ListColumn("HLT Code", ListDataColumn.TEXT, "code"),
    "hltName": new ListColumn("HLT Name", ListDataColumn.TEXT, "name"),
    "ptCode": new ListColumn("PT Code", ListDataColumn.TEXT, "code"),
    "ptName": new ListColumn("PT Name", ListDataColumn.TEXT, "name"),
    "lltCode": new ListColumn("LLT Code", ListDataColumn.TEXT, "code"),
    "lltName": new ListColumn("LLT Name", ListDataColumn.TEXT, "name"),
    "lltDeprecated": new ListColumn("Is Deprecated", ListDataColumn.TEXT, "lltDeprecated"),
    "numHLGT": new ListColumn("Number of HLGTs", ListDataColumn.TEXT, "numHLGT"),
    "numHLT": new ListColumn("Number of HLTs", ListDataColumn.TEXT, "numHLT"),
    "numPT": new ListColumn("Number of PTs", ListDataColumn.TEXT, "numPT"),
    "numLLT": new ListColumn("Number of LLTs", ListDataColumn.TEXT, "numLLT")
  };

  export const MINIMUM_TREE_WITDH: number = 400;
  
  // Constant with styles for Formly Query Components
  export const LABELSTYLE: { [key in string]: string } = {
    // WebTrader Conditions Constants
    'queryInboxConditions': 'min-width:380px;text-align:right',
    'queryOutboxConditions': 'min-width:220px;text-align:right',
    'queryToEudravigilance': 'min-width:220px;text-align:right',
    'queryFromEudravigilance':'min-width:380px;text-align:right',

    // Medicinal Product Conditions Constants
    'mahsConditions': 'min-width:285px;text-align:right',
    'sponsorConditions': 'min-width:285px;text-align:right',
    'atcCodeConditions': 'min-width:285px;text-align:right',
    'sourceConditions': 'min-width:285px;text-align:right',
    'pharmaceuticalFormsConditions': 'min-width:325px;text-align:right',
    'roaConditions': 'min-width:340px;text-align:right',  
    'attachmentConditions': 'min-width:285px;text-align:right',
    'mflConditions': 'min-width:305px;text-align:right',
    'approvedSubstancesConditions': 'min-width:330px;text-align:right',  
    'substancesNamesConditions': 'min-width:135px;text-align:right',  
    'developmentSubstancesConditions': 'min-width:285px;text-align:right',
    'authorisedProductsConditions': 'min-width:340px;text-align:right',
    'developmentProductsConditions': 'min-width:340px;text-align:right',  
    'ownedByEVMPDEntitiesConditions': 'min-width:255px;text-align:right',
    'abstractCompositionsConditions': 'min-width:410px;text-align:right',
    'xevprmMessageConditions': 'min-width:410px;text-align:right',

    // Meddra Conditions Constants
    'queryConditions': 'min-width:185px;text-align:right',  

}

export const PLACEHOLDER: {[key in string]: string} = {
  'section': 'Choose a section',
  'element': 'Choose an element',
  'predicate': 'Choose a predicate',
  'chooseValue': 'Choose a value',
  'enterValue': 'Enter a value',
  'chooseAction': 'Choose an action'
}

/* For logic to compare type of entities */
export const TYPE_DICTIONARY: { [key in string]: string } = {
    'authorisedProduct': 'product',
    'authorisedProductLastVersion': 'product',
    'authorisedProductValidVersion': 'product',
    'authorisedProductOwned': 'product',
    'authorisedProductFollowUp': 'product',
    'developmentProduct': 'product',
    'developmentProductLastVersion': 'product',
    'developmentProductValidVersion': 'product',
    'developmentProductOwned': 'product',
    'mah': 'organisation',
    'sponsor': 'organisation'
}

/* Entity names for displaying in the messages */
export const TYPE_DICTIONARY_LABEL: { [key in string]: string } = {
    'product': 'Entity/entities',
    'organisation': 'Entity/entities'
}